const { v4: uuidv4 } = require('uuid');

export class Document {
  static newId(): string {
    return uuidv4();
  }
}
